import type { DateSerializable } from '@vs-shop/schemas/DateSerializable';
import { Match } from 'effect';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../utils/intl';

import { IntlDate } from '../intl/Intl';

import { RuntimeDate } from '@vs-shop/engine/runtime/RuntimeDate';
import { getDispatchDateResult } from '../../../effect/utils/domain/dispatchDate';

type Props = {
  date: DateSerializable | null;
};

export default function DispatchDate({ date }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const result = getDispatchDateResult(date).pipe(RuntimeDate.runSync);

  return Match.value(result).pipe(
    Match.tag('Today', () =>
      intl.formatMessage({
        id: 'common.today',
        defaultMessage: 'dnes',
      })
    ),
    Match.tag('Tomorrow', () =>
      intl.formatMessage({
        id: 'common.tomorrow',
        defaultMessage: 'zítra',
      })
    ),
    Match.tag('DayAfterTomorrow', () =>
      intl.formatMessage({
        id: 'common.dayAfterTomorrow',
        defaultMessage: 'pozítří',
      })
    ),
    Match.tag('Later', ({ date }) => <IntlDate value={date} />),
    Match.tag('NoDate', () => null),
    Match.exhaustive
  );
}
